import { render, staticRenderFns } from "./Subcategories.vue?vue&type=template&id=4f342795"
import script from "./Subcategories.vue?vue&type=script&lang=js"
export * from "./Subcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports